import { SendMessageImage } from "../../../svg";

export const Text = "Send App Link to your phone:";
export const BtnTxt = "Send Link";
export const MobileImg = <SendMessageImage />;
